import axios from "axios";

/**
 * Export contracts for the given office codes and search filters,
 * then trigger a browser download of the generated Excel file.
 *
 * @param {string[]} officeCodes - Office codes for the "Office-Code" header.
 * @param {{ query: string, status: string | null }} searchRequest - Search filters.
 * @param {number} [page=0] - Page index for export.
 * @param {number} [size=1000] - Page size for export.
 * @returns {Promise<void>}
 */
export const exportContractsExcel = async (
  token,
  officeCodes,
  searchRequest,
  page = 0,
  size
) => {
  try {
    console.log("Exporting contracts with searchRequest:", searchRequest);
    console.log("size:", size);
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/bulk-upload/organizations/export?page=${page}&size=${size}`,
      searchRequest,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Office-Code": officeCodes.join(","),
        },
        responseType: "blob",
      }
    );

    const blob = response.data;

    const contentDisposition = response.headers["content-disposition"];
    let fileName = "Contracts_Export.xlsx";

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?(.*?)"?$/i);
      if (match && match[1]) {
        fileName = match[1];
      }
    }

    // Create a temporary link to trigger the download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting contracts:", error);
    throw error; // let the caller decide how to handle UI errors
  }
};
